package com.alpha.showcase.common.ui.play

import androidx.compose.animation.core.tween
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.pager.HorizontalPager
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.runtime.getValue
import androidx.compose.runtime.setValue
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.geometry.Rect
import androidx.compose.ui.geometry.Size
import androidx.compose.ui.geometry.center
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.Outline
import androidx.compose.ui.graphics.Path
import androidx.compose.ui.graphics.Shape
import androidx.compose.ui.graphics.graphicsLayer
import androidx.compose.ui.unit.Density
import androidx.compose.ui.unit.LayoutDirection
import com.alpha.showcase.common.ui.play.flip.endOffsetForPage
import com.alpha.showcase.common.ui.play.flip.offsetForPage
import com.alpha.showcase.common.ui.play.flip.startOffsetForPage
import com.alpha.showcase.common.ui.settings.SHOWCASE_MODE_SLIDE
import kotlinx.coroutines.CancellationException
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import kotlin.math.absoluteValue
import kotlin.math.sqrt

@Composable
fun CircleRevealPager(interval: Long = DEFAULT_PERIOD, data: PagingPlayItems, fitSize: Boolean = false, showProgress: Boolean = true) {
    val controller = rememberInfinitePagerController(data)
    val pagerState = controller.pagerState
    val mediaStates = rememberMediaItemStateStore(fitSize)
    val overlayConfig = MediaOverlayConfig.forStyle(SHOWCASE_MODE_SLIDE)
//    LaunchedEffect(Unit) {
//        while (isActive) {
//            delay(if (interval <= 1) DEFAULT_PERIOD else interval)
//            if (pagerState.canScrollForward) {
//                pagerState.animateScrollToPage(pagerState.currentPage + 1, animationSpec = tween(2000))
//            } else {
//                pagerState.animateScrollToPage(0)
//            }
//        }
//    }
    var showOpButton by remember { mutableStateOf(false) }
    var offsetY by remember { mutableStateOf(0f) }
    var scope = rememberCoroutineScope()
    PagerMediaViewport(
        state = pagerState,
        modifier = Modifier.fillMaxSize(),
        onInteraction = {
            showOpButton = true
            val page = pagerState.currentPage
            mediaStates.get(page, controller.item(page), fitSize).interact(overlayConfig)
        },
    ) {
        HorizontalPager(
            modifier = Modifier
//                .pointerInteropFilter {
//                    offsetY = it.y
//                    false
//                }
//            .clip(
//                RoundedCornerShape(25.dp)
//            )
            ,
            state = pagerState,
        ) { page ->
            Box(
                modifier = Modifier
                    .fillMaxSize()
                    .graphicsLayer {
                        val pageOffset = pagerState.offsetForPage(page)
                        if (pageOffset != 0f){
                            translationX = size.width * pageOffset

                            val endOffset = pagerState.endOffsetForPage(page)

                            shadowElevation = 20f
                            shape = CirclePath(
                                progress = 1f - endOffset.absoluteValue,
                                origin = Offset(
                                    size.width,
                                    offsetY,
                                )
                            )
                            clip = true

                            val absoluteOffset = pagerState.offsetForPage(page).absoluteValue
                            val scale = 1f + (absoluteOffset.absoluteValue * .4f)

                            scaleX = scale
                            scaleY = scale

                            val startOffset = pagerState.startOffsetForPage(page)
                            alpha = (2f - startOffset) / 2f
                        }


                    },
                contentAlignment = Alignment.Center,
            ) {
                val mediaState = mediaStates.get(page, controller.item(page), fitSize)
                PagerItem(
                    modifier = Modifier.fillMaxSize(),
                    state = mediaState,
                    onInteraction = { mediaState.interact(overlayConfig, it) },
                    active = page == pagerState.currentPage
                ){
                    if (it.isVideo()){
                        scope.launch {
                            try {
                                if (pagerState.canScrollForward) {
                                    pagerState.animateScrollToPage(
                                        page = pagerState.currentPage + 1,
                                        animationSpec = tween(800)
                                    )
                                } else {
                                    pagerState.animateScrollToPage(
                                        page = 0
                                    )
                                }
                            }catch (e: CancellationException){
                                throw e
                            }
                        }
                    }
                }
//            Box(
//                modifier = Modifier
//                    .align(Alignment.BottomCenter)
//                    .fillMaxWidth()
//                    .fillMaxHeight(.8f)
//                    .background(
//                        brush = Brush.verticalGradient(
//                            listOf(
//                                Color.Black.copy(alpha = 0f),
//                                Color.Black.copy(alpha = .7f),
//                            )
//                        )
//                    )
//            )
            }
        }

        MediaOverlayTransition(
            mediaStates.get(pagerState.currentPage, controller.item(pagerState.currentPage), fitSize),
            SHOWCASE_MODE_SLIDE,
            summaryVisible = !pagerState.isScrollInProgress,
        )
        val progressDuration = interval.takeIf { it > 0 } ?: DEFAULT_PERIOD
        val progress = rememberPagerImagePlaybackProgress(
            pagerState, interval, controller.displaySize, animationMillis = 2000,
        ) { page -> mediaStates.get(page, controller.item(page), fitSize) }
        PlaybackProgressBar(
            elapsedMillis = { progress.value * progressDuration },
            durationMillis = progressDuration,
            visible = showProgress && !pagerState.isScrollInProgress
                && controller.displaySize > 1 && !controller.item(pagerState.currentPage).isVideo(),
            modifier = Modifier.align(Alignment.BottomCenter),
        )

        ChangePage(pagerState, showOpButton)
    }

}

class CirclePath(private val progress: Float, private val origin: Offset = Offset(0f, 0f)) : Shape {
    override fun createOutline(
        size: Size, layoutDirection: LayoutDirection, density: Density
    ): Outline {

        val center = Offset(
            x = size.center.x - ((size.center.x - origin.x) * (1f - progress)),
            y = size.center.y - ((size.center.y - origin.y) * (1f - progress)),
        )
        val radius = (sqrt(
            size.height * size.height + size.width * size.width
        ) * .5f) * progress

        return Outline.Generic(Path().apply {
            addOval(
                Rect(
                    center = center,
                    radius = radius,
                )
            )
        })
    }
}
